import {
  TeamOutlined,
  UsergroupAddOutlined,
  SettingOutlined,
  FileTextOutlined,
  CalendarOutlined,
} from '@ant-design/icons';
import { Button, Col, Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useLoggedInUser } from '../../hooks/useLoggedInUser';
import { usePermission } from '../../hooks/usePermission';
import routes from '../App/routes';
import LoginErrorPage from '../LoginErrorPage';
import PageLoadingSpinner from '../PageLoadingSpinner';
import { Optional } from '../Shared';

const homeButtonStyle = {
  width: '10em',
  height: '10em',
  fontSize: '1.1em',
  boxShadow: '0px 0px 15px lightGrey',
  marginBottom: '10px',
};

const iconStyle = { fontSize: '4em' };

const icon = (element: JSX.Element, text: string) => (
  <div>
    {element}
    <p style={{ fontSize: '1em', margin: 0 }}>{text}</p>
  </div>
);

/**
 * Renders the home page of PRAS application.
 */
const Home = () => {
  const navigate = useNavigate();
  const { loggedInUser, previousData } = useLoggedInUser();
  const permission = usePermission(undefined, loggedInUser);

  return loggedInUser !== undefined && previousData !== undefined ? (
    <Row style={{ justifyContent: 'center' }} gutter={10}>
      <Col>
        <Button
          type="default"
          className="home-button"
          id="Home-allteams-btn"
          icon={icon(<TeamOutlined style={iconStyle} />, 'All Teams')}
          style={homeButtonStyle}
          onClick={() => navigate(routes.allTeams)}
        />
      </Col>
      <Col>
        <Button
          type="default"
          className="home-button"
          id="Home-newteams-btn"
          icon={icon(<UsergroupAddOutlined style={iconStyle} />, 'New Team')}
          style={homeButtonStyle}
          onClick={() => navigate(routes.newTeam)}
        />
      </Col>
      <Col>
        <Button
          type="default"
          className="home-button"
          id="Home-daily-roster-btn"
          icon={icon(<CalendarOutlined style={iconStyle} />, 'Daily Roster')}
          style={homeButtonStyle}
          onClick={() => navigate(routes.dailyRoster)}
        />
      </Col>
      <Optional show={permission.teamRoleManage}>
        <Col>
          <Button
            type="default"
            className="home-button"
            id="Home-export-data-btn"
            icon={icon(<FileTextOutlined style={iconStyle} />, 'Export Data')}
            style={homeButtonStyle}
            onClick={() => navigate(routes.exportData)}
          />
        </Col>
        <Col>
          <Button
            type="default"
            className="home-button"
            id="Home-settings-btn"
            icon={icon(<SettingOutlined style={iconStyle} />, 'Settings')}
            style={homeButtonStyle}
            onClick={() => navigate(routes.teamSettings)}
          />
        </Col>
      </Optional>
    </Row>
  ) : loggedInUser === undefined && previousData === undefined ? (
    <PageLoadingSpinner />
  ) : (
    <LoginErrorPage />
  );
};

export default Home;
